export default {"src":"/_next/static/media/tablet-minor.898a8610.svg","height":75,"width":80};